<span class="snack-message">
  {{ data }}
</span>
